import { render, staticRenderFns } from "./all-branches.vue?vue&type=template&id=c2b8ac44&scoped=true"
import script from "./all-branches.vue?vue&type=script&lang=js"
export * from "./all-branches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b8ac44",
  null
  
)

export default component.exports